import { Button, DatePicker, Row , Col , Form, message, Radio, Select} from "antd";
import React, { useState , useRef} from "react";
import { useDispatch } from "react-redux";
import '../styles/agent-transactions.style.scss';
import { isValid } from "../utils/utilities";
import { fetchAgentLedger } from "../actions/agents.actions";
import moment from 'moment';
import { getAPIDateFormat, getUIDateFormat } from "../utils/date.utils";
import { useLocation } from "react-router-dom";
import { loadingAction } from '../actions/loading-actions';
import { AgentLedgerComponent } from "../components/agents-ledger-component/agent-ledger.component";
import { getRangeOptions } from "./reports/reports.module";

const { RangePicker } = DatePicker;


const DrawLine =()=>{

    return(
        <div className="agents-transactions-underline">

        </div>
    )
}

const Title = () =>{
        return (
            <div className="title-agent-transactions">
                <h3>
                    Agents Ledger
                </h3>
                <DrawLine />
            </div>
        )
}

export const AgentLedgerPage = (props) => {

    const [ agentsLedgerData , setAgentsLedgerData] = useState({});

    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const searchRef = useRef(null);


    const location = useLocation()
    let agentId = null;
    if(isValid(location.state)){
        agentId = location.state.agentId;
    }


    const setLoading =(bool)=>{
        dispatch(loadingAction(bool));
    }

    const onSuccess = (agentsLedger) => {
        setAgentsLedgerData(agentsLedger);
        setLoading(false);
    }

    const onFailure = () => {
        message.error("Failed to fetch agents ledger data.");
        setLoading(false);
    }

    const onFinish=(values)=>{
        let {
            dateRange, busType, isBookingDate
        } = values;
        let startDate = getAPIDateFormat(dateRange[0]);
        let endDate = getAPIDateFormat(dateRange[1]);
        setLoading(true);
        fetchAgentLedger(startDate,endDate,busType,isBookingDate,onSuccess,onFailure);
    }

    return (
        <div className="agents-page-root">
            <div className="agents-page-inner-div">
                <Title />
                <div className="marginBottom ticket-search-select">
                    <Form
                        form={form}
                        initialValues={{ 
                            dateRange: [moment().utcOffset("+05:30"),moment().utcOffset("+05:30")],
                            busType: 'allBuses',
                            isBookingDate: false
                        }}
                        className = "agent-form"
                        onFinish={onFinish}
                    >
                        <Row gutter={[16,16]}>
                            <Col>
                                <Form.Item
                                    name="isBookingDate"
                                    label=""
                                    rules={[{ required: true , message: 'Please select date type!'}]}
                                >
                                    <Select
                                        placeholder="Select date type"
                                        style={{ width: 150 }}
                                    >
                                        <Select.Option value={false}>Travel date</Select.Option>
                                        <Select.Option value={true}>Booking date</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item
                                    label=""
                                    rules={[{ required: true, message: 'Please input date' }]}
                                    name="dateRange"
                                    >
                                    <RangePicker ranges={getRangeOptions(31)} />
                                </Form.Item>
                            </Col>
                            <Col>
                            <Form.Item
                                  name="busType"
                                  label=""
                                  rules={[{ required: true , message: 'Please input your bus type!'}]}
                            >
                                    <Radio.Group name="radiogroup">
                                        <Radio value={'allBuses'}>All buses</Radio>
                                        <Radio value={'ac'}>A/C buses</Radio>
                                        <Radio value={'noAc'}>Non-A/C buses</Radio>
                                    </Radio.Group>
                            </Form.Item>
                            </Col>
                            <Col>
                                <Button htmlType="submit" ref={searchRef}>Search</Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
                <div>
                    {isValid(agentsLedgerData) && <AgentLedgerComponent
                     ledgerData = {agentsLedgerData}
                     dateRange = {form.getFieldValue('dateRange')}
                    />}
                </div>
            </div>
        </div>
    );
}